import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import {
  getData,
  getAllData,
  addRequestsData,
} from '../../api/indexedDBHandler'
import { useSnackbar } from '../../alert/SnackbarProvider'
import { useParams } from 'react-router-dom'
const CompetitonStep = forwardRef(({ defaultvar = '' }, ref) => {
  const [tournament, setTournament] = useState(defaultvar)
  const [name1step, setName1step] = useState(null)
  const [name2step, setName2step] = useState(null)
  const [name3step, setName3step] = useState(null)
  const [showAddStep, setShowAddStep] = useState(false)
  const [availableTournaments, setAvailableTournaments] = useState([])
  const [selectedTournament, setSelectedTournament] = useState('')
  const [stages, setStages] = useState(
    JSON.parse(defaultvar.stages_cup_id || '[]')
  )
  const showSnackbar = useSnackbar()
  const { id } = useParams()

  const getTournamentName = async (id) => {
    const results = await getData('tournaments', 'id', id)
    if (results.length > 0) {
      const { value } = results[0]
      return value.tournament_name
    }
    return ''
  }

  const handleAddStepClick = async () => {
    const tournaments = await getAllData('tournaments')
    // Фильтруем турниры, исключая уже добавленные этапы

    console.log('tournaments', tournaments)
    const filteredTournaments = tournaments.filter(
      (t) =>
        !stages.some((stage) => stage.id1 === t.value) &&
        t.status_cup !== 'Турнир завершен'
    )

    // const filteredTournaments2 = filteredTournaments.filter(
    //   (id) => !weighedTeamIds.includes(id)
    // )

    setAvailableTournaments(filteredTournaments)
    setShowAddStep(true)
  }

  const handleTournamentSelect = (event) => {
    setSelectedTournament(event.target.value)
  }

  const handleAddTournament = async () => {
    if (!selectedTournament) return

    const selected = availableTournaments.find(
      (t) => t.id === selectedTournament.id
    )

    if (selected) {
      const newStage = {
        id1: selected.id,
      }

      const updatedStages = [...stages, newStage]
      setStages(updatedStages)
      setShowAddStep(false)
      setSelectedTournament('')

      // Обновляем имена этапов
      getTournamentName(newStage.id1).then((name) => {
        if (stages.length === 0) {
          setName1step(name)
        } else if (stages.length === 1) {
          setName2step(name)
        } else if (stages.length === 2) {
          setName3step(name)
        }
      })
      //    stages_cup_id: '[{"id1":"' + idT + '"}]',
      const jsonString = JSON.stringify(updatedStages)
      console.log('updatedStages', jsonString)

      const update_data = {
        cup_id: id,
        stage: jsonString,
        requestKey: `${id}_updateTournaments_${new Date().getTime()}`,
      }

      try {
        await addRequestsData('requests', {
          url: 'tournaments/updateTournamentsStep.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 2000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        //   setLoading(false)
        showSnackbar('Данные сохранены', 'success')
      }
    }
  }

  const handleDeleteStage = async (index) => {
    // Проверяем условия удаления
    if (index === 0) return // Первый этап нельзя удалить

    // Если 3 этапа, можно удалить только последний
    if (stages.length === 3 && index !== 2) return

    const updatedStages = [...stages]
    updatedStages.splice(index, 1)
    setStages(updatedStages)

    // Обновляем имена этапов
    if (index === 1) {
      setName2step(name3step)
      setName3step(null)
    } else if (index === 2) {
      setName3step(null)
    }
    const jsonstages = JSON.stringify(stages)

    console.log('jsonstages', jsonstages)
    const jsonString = JSON.stringify(updatedStages)
    console.log('updatedStages', jsonString)

    const update_data = {
      cup_id: id,
      oldstage: jsonstages,
      stage: jsonString,
      requestKey: `${id}_updateTournaments_${new Date().getTime()}`,
    }

    try {
      await addRequestsData('requests', {
        url: 'tournaments/dellTournamentsStep.php',
        ...update_data,
      })
      await new Promise((resolve) => setTimeout(resolve, 2000))
    } catch (error) {
      showSnackbar('Ошибка сохранения', 'error')
    } finally {
      //   setLoading(false)
      showSnackbar('Данные сохранены', 'success')
    }
  }

  useEffect(() => {
    const loadStageNames = async () => {
      if (stages.length > 0) {
        setName1step(await getTournamentName(stages[0].id1))
      }
      if (stages.length > 1) {
        setName2step(await getTournamentName(stages[1].id1))
      }
      if (stages.length > 2) {
        setName3step(await getTournamentName(stages[2].id1))
      }
    }

    loadStageNames()
  }, [stages])

  useImperativeHandle(ref, () => ({
    getStages: () => stages,
  }))

  if (tournament !== '') {
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span" sx={{ width: '33%', flexShrink: 0 }}>
            Этапы
          </Typography>
          <Typography component="span" sx={{ color: 'text.secondary' }}>
            {stages.length} этап(ов)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/* Отображение текущих этапов */}
          <Box mt={2} mb={2}>
            <Typography variant="subtitle1" gutterBottom>
              Текущие этапы:
            </Typography>
            <Box component="ul" sx={{ pl: 2, mb: 2 }}>
              {name1step && (
                <Box
                  component="li"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography>{name1step}</Typography>
                  {/* Первый этап нельзя удалить - не показываем кнопку */}
                </Box>
              )}
              {name2step && (
                <Box
                  component="li"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography>{name2step}</Typography>
                  <IconButton
                    onClick={() => handleDeleteStage(1)}
                    disabled={stages.length === 3} // Если 3 этапа, можно удалять только последний
                    size="small"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}
              {name3step && (
                <Box
                  component="li"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography>{name3step}</Typography>
                  <IconButton onClick={() => handleDeleteStage(2)} size="small">
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Box>

          {/* Секция добавления нового этапа */}
          {showAddStep && (
            <Box sx={{ mt: 3, mb: 2 }}>
              <TextField
                id="tournament_draw"
                select
                label="Выберите турнир для добавления"
                value={selectedTournament}
                onChange={handleTournamentSelect}
                variant="outlined"
                fullWidth
                size="small"
                sx={{ mb: 2 }}
              >
                {availableTournaments.map((option) => (
                  <MenuItem key={option.value} value={option}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span>{option.tournament_name}</span>
                      <span style={{ fontSize: '0.8em', color: 'gray' }}>
                        {option.water_body}
                      </span>
                    </div>
                  </MenuItem>
                ))}
              </TextField>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button
                  onClick={() => setShowAddStep(false)}
                  variant="outlined"
                  size="small"
                >
                  Отмена
                </Button>
                <Button
                  onClick={handleAddTournament}
                  variant="contained"
                  size="small"
                  color="success"
                  disabled={!selectedTournament}
                >
                  Сохранить
                </Button>
              </Box>
            </Box>
          )}

          <Typography
            variant="caption"
            gutterBottom
            sx={{ display: 'block', mt: 2 }}
          >
            В многоэтапных турнирах будут формироваться дополнительные протоколы
            на основе суммы баллов завершённых этапов. Они доступны только в
            парных соревнованиях с определением победителя по общему весу. Для
            создания других этапов: сначала создайте турнир, затем выберите его
            из списка.
          </Typography>

          {!showAddStep && (
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                onClick={handleAddStepClick}
                variant="outlined"
                size="small"
                disabled={stages.length >= 3} // Максимум 3 этапа
              >
                Добавить этап
              </Button>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    )
  }

  return null
})

export default CompetitonStep
